<template>
    <div class="home">
        <div class="videos">
            <div class="bgimg">
                <img :src="bgUrl" alt="">
                <!-- <img src="@/assets/images/home/bg.png" alt=""> -->
            </div>
            <div class="contain">
                <div class="contain-left" v-if="!$utils.isArrayEmpty(videoList)">
                    <video id="videos" muted  autoplay controlsList="nodownload" :src="videoUrl" controls :poster="videobgUrl"></video>
                    <!-- <video src="@/assets/images/home/2.mp4" controls></video> -->
                    <!-- <video-player  class="video-player vjs-custom-skin"
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions"
                    ></video-player> -->
                </div>
                <ul class="contain-right" >
                    <li v-for="(item,index) in videoList" :key="index" :class="index==active?'border':''" @click="tabChange(item,index)" :title="item.title">
                        <div v-if="index!=active" class="boxshadow"></div>
                        <div v-if="index==active" class="Slider-clickPoint"></div>
                        <img :class="index==active?'noborder':''" :src="item.coverImg" alt="">
                    </li>
                </ul>
            </div>
        </div>
        <section class="gray1">
            <div class="boxes one w1200">
                <div class="title">
                    <div class="title-name">
                        <img src="@/assets/images/home/p1.png" alt="">
                        <span>{{ $t('home.Home.239361-0') }}</span>
                    </div>
                    <div class="title-more" @click="goRecommend(1)">
                        {{ $t('home.Home.239361-1') }}<i class="el-icon-d-arrow-right"></i>
                    </div>
                </div>
                <ul class="contian">
                    <li v-for="(item,index) in hotList" :key="index">
                        <cardItem :origin="item.origin" :detail="item"></cardItem>
                    </li>
                </ul>
            </div>
        </section>
        <section class="gray2">
            <div class="twoBox">
                <div class="boxes w956">
                    <div class="title">
                        <div class="title-name">
                            <img src="@/assets/images/home/p2.png" alt="">
                            <span>{{ $t('home.Home.239361-2') }}</span>
                        </div>
                        <div class="title-more" @click="goRecommend(2)">
                            {{ $t('home.Home.239361-1') }}<i class="el-icon-d-arrow-right"></i>
                        </div>
                    </div>
                    <ul class="contian">
                        <li v-for="(item,index) in newList" :key="index">
                            <cardItem :detail="item"></cardItem>
                        </li>
                    </ul>
                </div>
                <div class="boxes w224 lives">
                    <div class="title">
                        <div class="title-name">
                            <img src="@/assets/images/home/p3.png" alt="">
                            <span>{{ $t('home.Home.239361-3') }}</span>
                        </div>
                        <div class="title-more" @click="goLives">
                            {{ $t('home.Home.239361-1') }}<i class="el-icon-d-arrow-right"></i>
                        </div>
                    </div>
                    <ul class="contain" v-if="!$utils.isArrayEmpty(LiveList)">
                        <li v-for="(item,index) in LiveList" :key="index" :class="liveActive==index ? 'active':''" @click="showInfo(index)">
                            <div class="info">
                                <div class="title">
                                    <i v-if="liveActive==index" class="el-icon-star-on"></i>
                                    <div v-else class="cir">
                                        
                                    </div>
                                    <p class="p1" :title="item.title"><span>{{item.title}}</span></p>
                                </div>
                                <!-- div. -->
                                <div class="note" :class="liveActive==index?'block':''" @click="goLivesUrl(item.liveUrl)">
                                    <p>{{ $t('home.Home.239361-4') }}{{item.author}}</p>
                                    <p>{{item.startTime}}</p>
                                    <p>{{item.endTime}}</p>
                                    <p>{{item.content}}</p>
                                </div>
                            </div>
                            <div class="line"></div>
                        </li>
                    </ul>
                    <div class="over" v-else>
                        {{ $t('home.Home.239361-5') }}
                    </div>
                    <!-- <ul class="contian">
                        <li v-for="(item,index) in hotList" :key="index">
                            <cardItem :detail="item"></cardItem>
                        </li>
                    </ul> -->
                </div>
            </div>
        </section>
        <section class="gray1">
            <div class="twoBox">
                <div class="boxes school">
                    <div class="title">
                        <div class="title-name">
                            <img src="@/assets/images/home/p4.png" alt="">
                            <span>{{ $t('home.Home.239361-6') }}</span>
                        </div>
                        <!-- <div class="title-more">
                            {{ $t('home.Home.239361-1') }}<i class="el-icon-d-arrow-right"></i>
                        </div> -->
                    </div>
                    <div class="box">
                        <ul class="contian">
                            <li v-for="(item,index) in schoolList" :key="index">
                                <sortCard :origin="2"  :text="$t('home.Home.239361-7')" :detail="item" :number="index"></sortCard>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="boxes schoolSource">
                    <div class="title">
                        <div class="title-name">
                            <img src="@/assets/images/home/p5.png" alt="">
                            <span>{{ $t('home.Home.239361-8') }}</span>
                        </div>
                        <!-- <div class="title-more">
                            {{ $t('home.Home.239361-1') }}<i class="el-icon-d-arrow-right"></i>
                        </div> -->
                    </div>
                    <div class="box">
                        <div class="bar">
                            <canvasBar v-if="!$utils.isArrayEmpty(canvasBarList)" :canvasList="canvasBarList"></canvasBar>
                        </div>
                        <div class="pie">
                            <canvasPie v-if="!$utils.isArrayEmpty(canvasPieList)" :canvasList="canvasPieList"></canvasPie>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="gray1">
            <div class="twoBox">
                <div class="boxes teachersort">
                    <div class="title">
                        <div class="title-name">
                            <img src="@/assets/images/home/p6.png" alt="">
                            <span>{{ $t('home.Home.239361-9') }}</span>
                        </div>
                        <!-- <div class="title-more">
                            {{ $t('home.Home.239361-1') }}<i class="el-icon-d-arrow-right"></i>
                        </div> -->
                    </div>
                    <div class="box">
                        <ul class="contian">
                            <li v-for="(item,index) in teacherList" :key="index">
                                <sortCard :origin="1" :text="$t('home.Home.239361-10')" :detail="item" :number="index"></sortCard>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="boxes sourcesort">
                    <div class="title">
                        <div class="title-name">
                            <img src="@/assets/images/home/p7.png" alt="">
                            <span>{{ $t('home.Home.239361-11') }}</span>
                        </div>
                        <!-- <div class="title-more">
                            {{ $t('home.Home.239361-1') }}<i class="el-icon-d-arrow-right"></i>
                        </div> -->
                    </div>
                    <div class="box" v-if="sourcesort">
                        <div class="total">
                            <img src="@/assets/images/home/sort.png" alt="">
                            <p class="p1">{{sourcesort.totalBrowseCount||0}}</p>
                            <p class="p2">{{ $t('home.Home.239361-12') }}</p>
                        </div>
                        <ul class="contian">
                            <li v-for="(item,index) in sourcesort.resList" :key="index">
                                <ul class="cont-ul" @click="goPubilcDetail(item)">
                                    <li class="imgs">
                                        <img v-if="index==0" src="@/assets/images/home/sort1.png" alt="">
                                        <img v-else-if="index==1" src="@/assets/images/home/sort2.png" alt="">
                                        <img v-else-if="index==2" src="@/assets/images/home/sort3.png" alt="">
                                    </li>
                                    <li :class="index==0?'top1':index==1?'top2':index==2?'top3':''">
                                        {{index+1}}
                                    </li>
                                    <li class="titles" :class="index==0||index==1||index==2?'col333':''">
                                        <p class="p1" :title="item.title">{{item.title}}</p>
                                        <p class="p2" :title="item.browseCount||0">{{item.browseCount||0}} {{ }}</p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import cardItem from 'components/cardItem/cardItem'
import sortCard from './components/sortCard'
import canvasPie from './components/canvasPie'

import canvasBar from './components/canvasBar'
import * as api_home from 'service/api/methods/api_home.js';
export default {
    components:{
        cardItem,sortCard,canvasPie,canvasBar
    },
    data(){
        return{
            bgUrl:'',
            baseUrl:'',
            active:0,
            videoUrl:'',
            videoList:[
                // {id:1,"coverImg": require("../../../assets/images/home/car1.jpg"),videos:require("../../../assets/images/home/2.mp4")},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),videos:require("../../../assets/images/home/2.mp4")},
                // {id:1,"coverImg": require("../../../assets/images/home/car1.jpg"),videos:require("../../../assets/images/home/2.mp4")},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),videos:require("../../../assets/images/home/2.mp4")},
                // {id:1,"coverImg": require("../../../assets/images/home/car1.jpg"),videos:require("../../../assets/images/home/2.mp4")},
            ],
            hotList:[
                // {id:1,"coverImg": require("../../../assets/images/home/car1.jpg"),type:1,title:'公开课公开课公开课公开课公开课公开课公开课',zuozhe:'张三',praiseCount:1,browsingCount:3,saves:6},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',zuozhe:'张三2',praiseCount:11,browsingCount:31,saves:61},
                // {id:1,"coverImg": require("../../../assets/images/home/car1.jpg"),type:1,title:'公开课',zuozhe:'张三',praiseCount:1,browsingCount:3,longs:'05:30',saves:6},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',zuozhe:'张三2',praiseCount:11,browsingCount:31,saves:61},
                // {id:1,"coverImg": require("../../../assets/images/home/car1.jpg"),type:1,title:'公开课',zuozhe:'张三',praiseCount:1,browsingCount:3,longs:'05:30',saves:6},
            ],
            newList:[
                // {id:1,"coverImg": require("../../../assets/images/home/car1.jpg"),type:1,title:'公开课公开课公开课公开课公开课公开课公开课',zuozhe:'张三',praiseCount:1,browsingCount:3,longs:'05:30',saves:6},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',zuozhe:'张三2',praiseCount:11,browsingCount:31,longs:'05:30',saves:61},
                // {id:1,"coverImg": require("../../../assets/images/home/car1.jpg"),type:1,title:'公开课',zuozhe:'张三',praiseCount:1,browsingCount:3,longs:'05:30',saves:6},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',zuozhe:'张三2',praiseCount:11,browsingCount:31,saves:61},
                // {id:1,"coverImg": require("../../../assets/images/home/car1.jpg"),type:1,title:'公开课公开课公开课公开课公开课公开课公开课',zuozhe:'张三',praiseCount:1,browsingCount:3,longs:'05:30',saves:6},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',zuozhe:'张三2',praiseCount:11,browsingCount:31,saves:61},
                // {id:1,"coverImg": require("../../../assets/images/home/car1.jpg"),type:1,title:'公开课',zuozhe:'张三',praiseCount:1,browsingCount:3,longs:'05:30',saves:6},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',zuozhe:'张三2',praiseCount:11,browsingCount:31,longs:'05:30',saves:61},
            ],
            liveActive:0,
            LiveList:[
                // {id:1,startTime:'2021-08-21 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课不停学线上直播视频听课不停学线上直播视频',livePerson:'张素珍'},
                // {id:1,startTime:'2021-08-22 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课1不停学线上直播视频',livePerson:'张素珍1'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
                // {id:1,startTime:'2021-08-23 19:00:12',endTime:'2021-08-24 20:22:22',title:'听课2不停学线上直播视频',livePerson:'张素珍2'},
            ],
            schoolList:[
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',name:'张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2',praiseCount:11,browsingCount:31,longs:'05:30',saves:61},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',name:'张三2',praiseCount:11,browsingCount:31,longs:'05:30',saves:61},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',name:'张三2',praiseCount:11,browsingCount:31,longs:'05:30',saves:61},
            ],
            teacherList:[
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',name:'张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2张三2',praiseCount:11,browsingCount:31,longs:'05:30',saves:61},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',name:'张三2',praiseCount:11,browsingCount:31,longs:'05:30',saves:61},
                // {id:1,"coverImg": require("../../../assets/images/home/car2.jpeg"),type:2,title:'公开课2',name:'张三2',praiseCount:11,browsingCount:31,longs:'05:30',saves:61},
            ],
            canvasBarList:[],
            canvasPieList:[],
            sourcesort:{
                total:0,
                resList:[
                    // {id:1,title:'停课不停学线上直播课程停课不停学线上直播课程',total:6744222232},
                    // {id:1,title:'停课不停学线上直播课程1',total:67432},
                    // {id:1,title:'停课不停学线上直播课程2',total:67432},
                    // {id:1,title:'停课不停学线上直播课程3',total:67432},
                    // {id:1,title:'停课不停学线上直播课程4',total:67432},
                    // {id:1,title:'停课不停学线上直播课程5',total:67432},
                    // {id:1,title:'停课不停学线上直播课程6',total:67432},
                ]
            },
        //     playerOptions:{
        //         notSupportedMessage: '此视频暂无法播放，请稍后再试',
        //         autoplay: false, // 如果true,浏览器准备好时开始回放。
        //         muted: false, // 默认情况下将会消除任何音频。
        //         loop: false, // 导致视频一结束就重新开始。
        //         preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        //         language: 'zh-CN',
        //         aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        //         fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        //         sources: [{
        //           type: '', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
        //           src: "" // 视频url地址 
        //         }],
        //         poster:'',
        //     }
        }
    },
    created(){
        this.getdefaultImg();
        this.getresList({type:1,page:1,rows:5,allowRepeat:0});
        this.getresList({type:2,page:1,rows:8,allowRepeat:0});
        this.getpageList({page:1,rows:9});
        this.getVideoList();
        this.getstatisticList();
    },
    mounted(){
        // document.getElementById('videos').controlsList = "nodownload";//不允许下载
    },
    methods:{
        getData(params){
        },
        tabChange(item,index){
            this.active=index;
            this.videoUrl=item.previewUrl;
            this.videobgUrl=item.coverImg;
            // this.getFileName(item.previewUrl,item.coverImg);
        },
        // getFileName(fimeNames,coverImg){
        //     let  fileName = fimeNames.lastIndexOf(".");
        //     let  fileNameLength = fimeNames.length; 
        //     let  fileFormat = fimeNames.substring(fileName + 1,fileNameLength);
        //     if(fileFormat=='m3u8'){
        //         this.playerOptions.sources[0].type='application/x-mpegURL';
        //     }else{
        //         this.playerOptions.sources[0].type='video/mp4';
        //     }
        //     this.playerOptions.sources[0].src= fimeNames;
        //     this.playerOptions.poster=coverImg;
        // },
        goRecommend(type){
            this.$router.push({path:'/home/recommend',query:{type:type}});
        },
        showInfo(index){
            this.liveActive=index;
        },
        getdefaultImg(params){//默认播放背景图
            api_home.getdefaultImg(params).then((res)=>{
                this.bgUrl=res.data;
            }).catch(()=>{
            })
        },
        getresList(params){//热门推荐、最新推荐
            api_home.getresList(params).then((res)=>{
                if(params.type==1){//1-热门，2-最新
                    this.hotList=res.data.records;
                }else{
                    this.newList=res.data.records;
                }
            }).catch(()=>{
                this.hotList=[];
                this.newList=[];
            })
        },
        getpageList(params){//直播预告列表
            api_home.getpageList(params).then((res)=>{
                this.LiveList=res.data.records;
            }).catch(()=>{
                this.LiveList=[];
            })
        },
        getVideoList(params){//默认播放列表
            api_home.getVideoList(params).then((res)=>{
                if(!this.$utils.isArrayEmpty(res.data)){
                    this.videoList=res.data.slice(0,5);
                    this.videoUrl=this.videoList[0].previewUrl;
                    this.videobgUrl=this.videoList[0].coverImg;
                    // this.getFileName(this.videoList[0].previewUrl,this.videoList[0].coverImg);
                }
            }).catch(()=>{
                this.videoList=[];
            })
        },
        getstatisticList(params){//统计
            api_home.getstatisticList(params).then((res)=>{
                this.schoolList=res.data.schoolRanking;
                this.teacherList=res.data.teacherRanking;
                this.sourcesort=res.data.browseRanking;
                this.canvasBarList=res.data.subjectStat;
                this.canvasPieList=res.data.mainSubjectStat;
            }).catch(()=>{
                
            })
        },
        goPubilcDetail(item){
            this.$router.push({path:'/home/pubilcdetail',query:{id:item.id,browseType:1}});
        },
        goLives(){
            this.$router.push({path:'/home/lives'});

        },
        goLivesUrl(liveUrl){
            window.open(liveUrl,'_blank');
        }
    }
}
</script>
<style lang="less" scoped>
.home{
    width:100%;
    position: relative;
    .videos{
        position: relative;
        padding-bottom:15px;
        .bgimg{
            position: absolute;
            top:-66px;
            left:0;
            right:0;
            min-width:1920px;
            height: calc(100% + 66px);
            margin: 0 auto 0 auto;
            img{
                width:100%;
                height: 100%;
            }
        }
        .contain{
            position: relative;
            z-index: 20;
            width:1200px;
            height: 562px;
            margin: 0 auto;
            display: flex;
            justify-content: flex-start;
            background: rgba(0,0,0,.3);
            .contain-left{
                width:992px;
                height: 562px;
                // padding-top:2px;
                video{
                    width: 100%;
                    height: 100%;
                    vertical-align: baseline;
                }
            }
            .contain-right{
                width:208px;
                li{
                    margin:0 auto;
                    cursor: pointer;
                    position: relative;
                    border-radius: 10px;
                    // overflow: hidden;
                    box-sizing: content-box;
                    border:3px solid transparent;
                    width:185px;
                    height: 104px;
                    
                }
                .boxshadow{
                    content: "";
                    position: absolute;
                    display: block;
                    width:185px;
                    height: 100%;
                    background: rgba(0,0,0,.3);
                    z-index: 1;
                    border-radius: 10px;
                }
                .boxshadow:hover{
                    content: "";
                    position: absolute;
                    display: block;
                    width:185px;
                    height: 100%;
                    background: rgba(0,0,0,0);
                    z-index: 1;
                    border-radius: 10px;
                }
                li:first-child{
                    margin-top:8px;
                }
                .border{
                    border:3px solid #009A3E;
                }
                .noborder{
                    border-radius: 5px;
                }
                img{
                    width:100%;
                    height: 100%;
                    border-radius: 10px;
                }
                .Slider-clickPoint{
                    position: absolute;
                    top: 50%;
                    left: -10px;
                    margin-top: -5px;
                    z-index: 30;
                    width: 0;
                    height: 0;
                    border-top: 7px solid transparent;
                    border-right: 8px solid #009A3E;
                    border-bottom: 7px solid transparent;
                }
            }
        }
    }
    .gray1{
        background: #F4F5F8;
    }
    .gray2{
        background: #ECF1F8;
    }
    .twoBox{
        display: flex;
        justify-content: space-between;
        width:1200px;
        margin: 0 auto;
    }
    section{
        .w1200{
            width:1200px;
        }
        .w956{
            width:956px;
        }
        .w224{
            width:224px;
        }
        .one{
            margin: 0 auto;
        }
        .boxes{
            // margin: 0 auto;
            padding:30px 0;
            .title{
                display: flex;
                justify-content: space-between;
                align-items: baseline;
                margin-bottom:7px;
                .title-name{
                    display: flex;
                    align-items: center;
                    span{
                        margin-left:5px;
                        font-size: 18px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                        font-weight: 700;
                        color: #333333;
                    }
                    img{
                        width:28px;
                        height: 26px;
                    }
                }
                .title-more{
                    font-size: 13px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    color: #999999;
                    cursor: pointer;
                }
            }
            .contian{
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                li{
                    margin-right:20px;
                }
                li:last-child{
                    margin-right:0;
                }
            }
        }
        .lives{
            .contain{
                width:100%;
                height: 454px;
                overflow-y: auto;
                // margin:20px 0;
                background: #fff;
                border-radius: 10px;
                li{
                    padding:5px 5px 5px 5px;
                    width:calc(100% - 17px);
                    position: relative;
                    cursor: pointer;
                    .info{
                        position: relative;
                        .title{
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                            font-size: 13px;
                            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                            font-weight: 700;
                        }
                        i{
                            position: absolute;
                            left:2px;
                            top:3px;
                            z-index: 6;
                        }
                        .cir{
                            position: absolute;
                            left:1px;
                            z-index: 6;
                            
                                width:8px;
                                height: 8px;
                                background: #ededed;
                                border-radius: 50%;
                                border:3px solid #fff;
                            >div{
                            }
                        }
                        .p1{
                            color:#333;
                            margin-left:20px;
                            overflow:hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                        }
                        .note{
                            margin-left:20px;
                            padding:0 10px;
                            background: #ededed;
                            overflow: hidden;
                            display: none;
                            p{
                                margin:10px 0;
                                font-size: 13px;
                                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                                font-weight: 400;
                                color: #666666;
                            }
                        }
                        .block{
                            display: block !important;
                        }
                    }
                    .line{
                        z-index: 5;
                        position: absolute;
                        left:12px;
                        width:2px;
                        bottom:0;
                        height: 100%;
                        background: #ededed;
                        // border:1px solid #ededed;
                    }
                }
                li:first-child{
                    padding:20px 5px 5px 5px !important;
                }
                li:first-child .line{
                    height: 85% !important;
                    bottom:0 !important;
                    top:15% !important;
                }
                li:last-child{
                    padding:5px 5px 20px 5px;
                }
                li:last-child .line{
                    height: 90%;
                    top:0;
                    bottom:0;
                }
                .active{
                    color:#009A3E;
                }
            }
            .over{
                text-align: center;
                line-height: 454px;
                font-size: 13px;
                color:#666;
                background: #fff;
                border-radius: 10px;
            }
        }
        .school{
            width:468px;
            border-radius: 5px;
            .box{
                height: 260px;
                background: #fff;
                border-radius: 10px;
            }
            .contian{
                margin:0 auto;
                padding:40px 0 0 20px;
            }
        }
        .schoolSource{
            width:712px;
            border-radius: 5px;
            .box{
                display: flex;
                justify-content: space-between;
                background: #fff;
                height: 260px;
                border-radius: 10px;
            }
            .bar{
                width:510px;
            }
            .pie{
                width:200px;
            }
        }
        .teachersort{
            width:468px;
            border-radius: 5px;
            padding-top:0;
            .box{
                height: 260px;
                background: #fff;
                border-radius: 10px;
            }
            .contian{
                margin:0 auto;
                padding:40px 0 0 20px;
            }
        }
        .sourcesort{
            width:712px;
            border-radius: 5px;
            padding-top:0;
            .box{
                height: 187px;
                background: #fff;
                border-radius: 10px;
                padding:37px 39px 37px 62px;
                display: flex;
                justify-content: space-between;
            }
            .total{
                width:116px;
                margin-top:9px;
                text-align: center;
                img{
                    width:116px;
                    height: 116px;
                }
                .p1{
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                    font-weight: 700;
                    color: #009A3E;
                    padding:19px 0 7px 0;
                }
                .p2{
                    font-size: 13px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    color: #666666;
                }
            }
            .contian{
                margin:0 auto;
                padding-left: 45px;
                display: block;
                width:450px;
                font-size: 13px;
                font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                .cont-ul{
                    display: flex;
                    justify-content: flex-start;
                    font-weight: 400;
                    color:#666;
                    li{
                        cursor: pointer;
                        padding:5px 0;
                        margin-right:5px;
                    }
                    .imgs{
                        width:19px;
                        height: 15px;
                        img{
                            width:19px;
                            height: 15px;
                        }
                    }
                }
                .top1{
                    color: #EAB830;font-weight: 700;
                }
                .top2{
                    color: #C7C6C6;font-weight: 700;
                }
                .top3{
                    color: #C16F1E;font-weight: 700;
                }
                .col333{
                    color: #333333;
                }
                .titles{
                    width:363px;
                    display: flex;
                    justify-content: space-between;
                    .p1{
                        width:250px;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                    .p2{
                        width: 100px;
                        text-align: right;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        
                    }
                }
            }
        }
    }
    .w956{
        li:nth-child(5),li:nth-child(6),li:nth-child(7),li:nth-child(8){
            margin-top:20px;
        }
        li:nth-child(4n){
            margin-right:0 !important;
        }
    }
    
}
</style>